import React from "react";
import Image from "components/image";
import Link from "helpers/link";

const Hero = ({ data: { image, title, description, ctaButton } }) => (
    <div className="flex relative" style={{ marginTop: -16 }}>
        <div className="absolute w-full h-full z-0 before:z-10 before:top-0 before:right-0 before:left-0 before:bottom-0 before:absolute xsm:before:bg-gray-701 xsm:before:opacity-40">
            <Image image={image?.asset} className="w-full h-full" />
        </div>
        <div className="container flex flex-col font xsm:pt-8 pt-12 xsm:pb-24 pb-20 z-0">
            {title && (
                <h1 className="text-white mb-2 text-h3-xs md:text-h3 font-semibold leading-tight">
                    {title}
                </h1>
            )}
            {description && (
                <p className="text-white mb-5 md:mb-6">
                    {description}
                </p>
            ) }
            {ctaButton && (
                <div className="w-56 xl:w-80 xl:pr-6">
                    <Link className="btn-primary hover:text-white text-black-100 font-bold" to={ctaButton.url}>
                        {ctaButton.title}
                    </Link>
                </div>
            )}
        </div>
    </div>
);

export default Hero;
